import { type Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  lineDivider: {
    height: '2px',
    width: '100%',
    background: colors.gray.l94,
    position: 'relative',
    left: '0',
    bottom: '2px',
  },
  tabsContainer: {
    marginTop: '24px',
  },
  tabPanelContainer: {
    marginTop: '24px',
  },
  discoverTitle: {
    fontSize: '34px',
    fontWeight: 600,
    lineHeight: '40px',
    [theme.breakpoints.down(900)]: {
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '28px',
    },
  },
}));
